export default "__VITE_ASSET__8fed7a77__"